var CreateGpuProcessor = require('../../utils/gpu-processor/gpu-processor')

var DuplicateBufferGeometry = require('../../utils/duplicate-buffer-geometry')
var CopyTexture = require('../../utils/gpu-processor/copy-texture')

const PASS_THROUGH_VERT = "void main() { gl_Position = vec4( position, 1.0 ); }"

function _generatePositionFn( config ) {
	
	return function generatePosition( data, i ) {

		data[i+0] = Math.random() * 0.01 + ( Math.cos(i * 0.02) + Math.cos(i * 0.2 )* 0.01) * 3
		data[i+1] = Math.random() * 0.01 + ( Math.sin(i * 0.02) + Math.sin(i * 0.2 )* 0.01) * 3
		data[i+2] = Math.random() * 0.01 +  2 + -i * 0.00002
		
		data[i+0] += Math.sin( data[i+2] ) * 0.1
	}
}

function _initPositioningPass( gpuProcessor, config ) {
	
	var prevPositionTexture // created at the end
	
	var shaderMaterial = new THREE.ShaderMaterial({
		
		vertexShader : PASS_THROUGH_VERT,
		fragmentShader : "#define GLSLIFY 1\n\nuniform float textureSideLength;\n\nuniform sampler2D textureCurrPosition;\nuniform sampler2D texturePrevPosition;\n\n\nvoid main() {\n\t\n\tvec2 uv = gl_FragCoord.xy / textureSideLength;\n\tvec4 currPosition = texture2D( textureCurrPosition, uv );\n\tvec4 prevPosition = texture2D( texturePrevPosition, uv );\n\n\tvec3 velocity = currPosition.xyz - prevPosition.xyz;\n\tvec3 toOrigin = normalize(-1.0 * currPosition.xyz);\n\tvec3 orientation = normalize( velocity );\n\tvec3 newOrientation = normalize( mix( toOrigin, orientation, 0.93 ) );\n\tnewOrientation += vec3(0.0001, 0.0001, 0.0001);\n\tfloat velocityLength = length( velocity );\n\tfloat toOriginLength = length( currPosition.xyz );\n\t\n\tgl_FragColor = vec4(\n\t\tcurrPosition.xyz + newOrientation * 0.02,\n\t\t1.0\n\t);\n}",
		uniforms: {
			elapsed : { type : 'f' },
			textureSideLength : { type : 'f' },
			textureCurrPosition : { type : 't' },
			texturePrevPosition : { type : 't' }
		},
		attributes : {}
	})
	
	shaderMaterial.name = "Boids Position Shader"

	var pass = gpuProcessor.addPass( "position", {
		
		size              : config.count,  // Number of vectors in data
		stride            : 3,             // Dimensions of vectors, either 3 or 4
		uniformName       : "textureCurrPosition",
		shaderMaterial    : shaderMaterial,
		generateDatum     : _generatePositionFn( config ),
		preRender         : function( pass, passes ) {
			
			//Copy the previous position
			gpuProcessor.copyTexture(
				pass.outputRenderTarget,
				prevPositionTexture,
				pass.textureSideLength
			)
			
		}
	})
	
	//Copy one of the render target settings
	prevPositionTexture = pass.renderTargets[0].clone()
	prevPositionTexture.name = "prevPositionTexture"
	
	// //TODO - Debug only
	// gpuProcessor.copyTexture(
	// 	pass.renderTargets[0],
	// 	prevPositionTexture,
	// 	pass.textureSideLength
	// )
	
	shaderMaterial.uniforms.textureSideLength.value = pass.textureSideLength
	shaderMaterial.uniforms.texturePrevPosition.value = prevPositionTexture
	
	return {
		pass : pass,
		prevPositionTexture : prevPositionTexture,
		shaderMaterial : shaderMaterial
	}
}

function _createRenderMaterial( config ) {
	
	var shaderMaterial = new THREE.ShaderMaterial({
		
		vertexShader    : "#define GLSLIFY 1\n\nuniform float elapsed;\n\nuniform float textureSideLength;\nuniform sampler2D textureCurrPosition;\nuniform sampler2D texturePrevPosition;\n\nattribute float attributeIndex;\n\nvarying float vLighting;\nvarying float vAttributeIndex;\n\nvoid main() {\n\t\n\tvec2 positionLookup = vec2(\n\t\tmod(attributeIndex, textureSideLength),\n\t\tfloor(attributeIndex / textureSideLength)\n\t) / textureSideLength;\n\t\n\tvec3 currPosition = texture2D( textureCurrPosition, positionLookup ).xyz;\n\tvec3 prevPosition = texture2D( texturePrevPosition, positionLookup ).xyz;\n\t\n\tfloat theta = log(attributeIndex) * 8.0;\n\tfloat r = attributeIndex * 2.0;\n\t\n\tvec4 offset = vec4( r * sin(theta), r * cos(theta), 0.0, 0.0 );\n\t\n\tvLighting = dot( normal, normalize(cameraPosition - position) );\n\tvLighting = vLighting * 0.5 + 0.5;\n\t\n\tvAttributeIndex = attributeIndex;\n\t\n\tgl_Position =\n\t\tprojectionMatrix *\n\t\tmodelViewMatrix * (\n\t\t\tvec4( position, 1.0 ) + offset * 0.0 + vec4( currPosition * 100.0, 0 )\n\t\t);\n}",
		fragmentShader  : "#define GLSLIFY 1\n\nvarying float vLighting;\nvarying float vAttributeIndex;\n\nfloat hue2rgb_1_0(float f1, float f2, float hue) {\n    if (hue < 0.0)\n        hue += 1.0;\n    else if (hue > 1.0)\n        hue -= 1.0;\n    float res;\n    if ((6.0 * hue) < 1.0)\n        res = f1 + (f2 - f1) * 6.0 * hue;\n    else if ((2.0 * hue) < 1.0)\n        res = f2;\n    else if ((3.0 * hue) < 2.0)\n        res = f1 + (f2 - f1) * ((2.0 / 3.0) - hue) * 6.0;\n    else\n        res = f1;\n    return res;\n}\n\nvec3 hsl2rgb_1_1(vec3 hsl) {\n    vec3 rgb;\n    \n    if (hsl.y == 0.0) {\n        rgb = vec3(hsl.z); // Luminance\n    } else {\n        float f2;\n        \n        if (hsl.z < 0.5)\n            f2 = hsl.z * (1.0 + hsl.y);\n        else\n            f2 = hsl.z + hsl.y - hsl.y * hsl.z;\n            \n        float f1 = 2.0 * hsl.z - f2;\n        \n        rgb.r = hue2rgb_1_0(f1, f2, hsl.x + (1.0/3.0));\n        rgb.g = hue2rgb_1_0(f1, f2, hsl.x);\n        rgb.b = hue2rgb_1_0(f1, f2, hsl.x - (1.0/3.0));\n    }   \n    return rgb;\n}\n\nvec3 hsl2rgb_1_1(float h, float s, float l) {\n    return hsl2rgb_1_1(vec3(h, s, l));\n}\n\n\n\nvoid main() {\n\t\n\tgl_FragColor = vec4(\n\t\thsl2rgb_1_1( mod(0.5 + vAttributeIndex * 0.000002, 1.0), 0.8, 0.5 ),\n\t\t1.0\n\t) * vLighting;\n}",
		
		uniforms: {
			elapsed : { type: 'f', value : 0 },
			textureCurrPosition : { type : 't' },
			texturePrevPosition : { type : 't' },
			textureSideLength : { type : 'f' }
		},
		
		attributes       : {
			attributeIndex : { type: 'f' }
		}
	})
	
	shaderMaterial.name = "Boids Render Shader"
	
	return shaderMaterial
}

function _createGeometry( config ) {
	
	var bufferGeometry = new THREE.BufferGeometry()
	bufferGeometry.fromGeometry( new THREE.OctahedronGeometry( 3 ) )
	DuplicateBufferGeometry( bufferGeometry, config.count )

	return bufferGeometry
}

function _initRenderingPass( config, scene, positioning ) {
	
	var mesh = new THREE.Mesh(
		_createGeometry( config ),
		_createRenderMaterial( config, positioning )
	)
	
	scene.add( mesh )
	return mesh
}

module.exports = function fbo( poem, props ) {
	
	var config = _.extend({
		count : 1e5 * 2
	}, props)
	
	var gpuProcessor = CreateGpuProcessor( poem.renderer )
	var positioning = _initPositioningPass( gpuProcessor, config )
	
	
	var mesh = _initRenderingPass( config, poem.scene )
	
	poem.emitter.on('update' , function(e) {
		
		gpuProcessor.render()
		
		mesh.material.uniforms.textureCurrPosition.value = positioning.pass.outputRenderTarget
		// mesh.material.uniforms.textureCurrPosition.value = positioning.prevPositionTexture
		mesh.material.uniforms.texturePrevPosition.value = positioning.prevPositionTexture
		mesh.material.uniforms.textureSideLength.value = positioning.pass.textureSideLength
		mesh.material.uniforms.elapsed.value = e.elapsed
	})
}